import { graphql } from "msw";
import { mockCart, mockCartParcel, mockCartOrderSummary } from "./mockCart";
import {
  DeliveryType,
  UpdateCartShippingOptionMutationVariables,
  UpdateCartShippingOptionMutation,
} from "@cart-app/generated/graphql";

export const handler = graphql.mutation<
  UpdateCartShippingOptionMutation,
  UpdateCartShippingOptionMutationVariables
>("UpdateCartShippingOption", (req, res, ctx) => {
  const { type } = req.variables;

  const modifiedParcels = mockCartParcel.map((parcel) => {
    return {
      ...parcel,
      selectedShippingOption:
        parcel.shippingOptions.find((option) => option.type === type) || null,
    };
  });

  const newShippingCost = modifiedParcels.reduce(
    (acc, parcel) => acc + (parcel.selectedShippingOption?.price.amount || 0),
    0
  );

  const totalPrice =
    mockCartOrderSummary.totalPrice.amount -
    mockCartParcel.reduce(
      (acc, parcel) => acc + (parcel.selectedShippingOption?.price.amount || 0),
      0
    ) +
    newShippingCost;

  return res(
    ctx.data({
      updateCartShippingOption: {
        ...mockCart,
        parcels: modifiedParcels,
        orderSummary: {
          ...mockCartOrderSummary,
          delivery: {
            deliveryType: modifiedParcels[0]
              .selectedShippingOption as unknown as DeliveryType,
            total: {
              amount: newShippingCost,
            },
          },
          totalPrice: {
            ...mockCartOrderSummary.totalPrice,
            amount: totalPrice,
          },
        },
      },
    })
  );
});
